export default __webpack_public_path__ + "static/media/veterinary-briefcase.9c839ce0.svg";